import React from 'react';
import { useLoader, usePopup, useToast } from '../../../hooks';
import { FloatingNavigationMenu, Loading, PageHeader, PageHeaderProps, Popup, Snackbar } from '../..';
import { Container, Wrapper } from './styles';

type Props = PageHeaderProps & {
    showPageHeader?: boolean;
    showFloatingNavigationMenu?: boolean;
    hiddenMarginContent?: boolean;
    children: React.ReactNode;
}

const MainLayout: React.FC<Props> = ({
    showPageHeader = true,
    showFloatingNavigationMenu = true,
    hiddenMarginContent = false,
    children,
    ...rest
}) => {
    const { loading } = useLoader();
    const { toast } = useToast();
    const { popup } = usePopup();

    return (
        <>
            <Container>
                {loading && (
                    <Loading loading={loading} />
                )}
                {toast && (
                    <Snackbar
                        {...toast}
                    />
                )}
                {popup && (
                    <Popup {...popup} />
                )}
                {showPageHeader && (
                    <Wrapper>
                        <PageHeader
                            {...rest}
                        />
                    </Wrapper>
                )}
                {hiddenMarginContent ? (
                    <>
                        {children}
                    </>

                ) : (
                    <Wrapper>
                        {children}
                    </Wrapper>
                )}

            </Container>
            {showFloatingNavigationMenu && <FloatingNavigationMenu />}
        </>
    );
};

export { MainLayout };
